<template>
    <div>
        <el-form
                ref="form"
                :model="form"
                :rules="rules"
                v-loading="isBusy"
                element-loading-spinner="el-icon-loading"
                label-position="top"
        >
            <el-form-item prop="value">
                <template v-slot:label>
                    <el-tooltip
                        v-if="description"
                        effect="light"
                        :content="description"
                        placement="top-start"
                    >
                        <span>{{ name }} <i class="far fa-question-circle"></i></span>
                    </el-tooltip>
                    <span v-else>{{ name }}</span>
                </template>
                <el-input v-model="form.value" :placeholder="name"></el-input>
            </el-form-item>
        </el-form>
        <button class="btn btn-create px-4" @click="store">Store</button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import InputMixin from '../../mixins/inputs';

  export default {
    extends: BaseForm,

    mixins: [
      InputMixin,
    ],

    data() {
      return {
        form: {
          value: null,
        },
        rules: {
          value: [{validator: this.fieldExternalValidator}],
        },
      }
    },

    computed: {
      /**
       * @return {string}
       */
      name() {
        return _.get(this.model, 'name') || this.key;
      },

      /**
       * @return {string}
       */
      key() {
        return _.get(this.model, 'key');
      },

      /**
       * @return {string}
       */
      description() {
        return _.get(this.model, 'description');
      },
    },

    methods: {
      /**
       * @param {Object} model
       */
      initForm({value = null}) {
        this.form = {
          value,
        };
      },
    }
  }
</script>

